export default __webpack_public_path__ + "static/media/low carb.3e36ce51.jpg";